import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cv-warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.scss']
})
export class WarningDialogComponent implements OnInit {
    @Input() title: string;
    @Input() prompt: string;

    constructor(
        public modal: NgbActiveModal
    ) { }

    ngOnInit(): void {
    }

}
